import Cookies from "js-cookie";
import { compressToEncodedURIComponent as compress } from "lz-string";
import { COOKIE_NAME, getAppId } from "./config";
import { deleteCookies, getCookieRoot } from "./shared";
export function writeGladlySessionCookie() {
    try {
        const blob = localStorage.getItem(getAppId());
        if (!blob)
            return;
        const payload = adaptGladlyToCookieString(blob);
        deleteCookies(COOKIE_NAME);
        Cookies.set(COOKIE_NAME, compress(payload), {
            domain: getCookieRoot(),
            path: "/",
            sameSite: "lax",
            secure: true,
        });
    }
    catch (e) {
        console.warn("Failed to store chat session", e);
    }
}
const adaptGladlyToCookieString = (blob) => {
    const { values } = JSON.parse(blob);
    const { cohortId, isMinimized, selectedAnswer, locationHistory, user, provider, } = values;
    const payload = {
        values: {
            isMinimized: isMinimized === false ? false : true,
            ...(cohortId ? { cohortId } : {}),
            ...(selectedAnswer
                ? {
                    selectedAnswer: {
                        bodyHtml: selectedAnswer.bodyHtml,
                        language: selectedAnswer.language,
                        name: selectedAnswer.name,
                    },
                }
                : {}),
            ...(locationHistory ? { locationHistory } : {}),
            ...(user ? { user } : {}),
            ...(provider ? { provider } : {}),
        },
        updatedAt: values.updatedAt,
    };
    return JSON.stringify(payload);
};
